/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespFollowSearchBanner_user$ref = any;
type SbSharedFollowSearchProvider_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespNullSearchResults_user$ref: FragmentReference;
export type SbRespNullSearchResults_user = {|
  +$fragmentRefs: SbRespFollowSearchBanner_user$ref & SbSharedFollowSearchProvider_user$ref,
  +$refType: SbRespNullSearchResults_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1b80459e049e9b30d9d27099e75dfee0';
module.exports = node;
